import React from 'react';
import SeoLandingPage from '../components/SeoLandingPage';

const PageGestionPatrimoineAnnecy = () => (
  <SeoLandingPage
    slug="gestion-patrimoine-annecy"
    title="Gestion de patrimoine Annecy : conseiller indépendant CGP - Arthur Vacogne"
    description="Conseiller en gestion de patrimoine indépendant à Annecy et Annecy-le-Vieux (Haute-Savoie). Bilan patrimonial offert, optimisation fiscale, immobilier locatif, SCPI, assurance vie, retraite. Intervention France entière. Avis Google 5/5."
    keywords="gestion de patrimoine Annecy, conseiller en gestion de patrimoine Annecy, CGP Annecy, CGPI Annecy, gestionnaire de patrimoine Annecy-le-Vieux, conseiller financier Annecy, conseil patrimonial Haute-Savoie, audit patrimonial Annecy, bilan patrimonial gratuit Annecy"
    h1="Gestion de patrimoine à Annecy : un conseiller indépendant à votre écoute"
    subtitle="Vous cherchez un conseiller en gestion de patrimoine à Annecy ou Annecy-le-Vieux ? Arthur Vacogne, CIF indépendant inscrit à l'ORIAS, vous accompagne pour structurer, optimiser et faire évoluer votre patrimoine — du premier euro investi à la transmission familiale."
    schemaService="Gestion de patrimoine à Annecy"
    sections={[
      {
        title: "Pourquoi faire appel à un conseiller en gestion de patrimoine indépendant à Annecy ?",
        body: "Choisir un conseiller en gestion de patrimoine (CGP) indépendant à Annecy, c'est faire le choix d'une analyse impartiale, sans pression commerciale et adaptée à vos objectifs réels. Contrairement à votre banque ou à un assureur unique, un CGPI travaille avec plusieurs dizaines de partenaires et compare les solutions du marché pour ne retenir que celle qui correspond le mieux à votre profil de risque et à votre horizon d'investissement.",
        bullets: [
          "Approche 100 % indépendante : aucun produit imposé",
          "Aucun honoraire client : rémunération uniquement par les partenaires partenaires de solutions",
          "Connaissance fine du marché annécien, du Genevois et de la Haute-Savoie",
          "Disponibilité en visio partout en France et Suisse",
          "Suivi long terme : ajustements à chaque étape de vie"
        ]
      },
      {
        title: "Mon accompagnement à Annecy : une démarche en 3 étapes",
        body: "Quel que soit votre niveau de patrimoine, l'accompagnement suit toujours la même méthodologie rigoureuse, conçue pour vous donner une vision claire et des solutions concrètes.",
        bullets: [
          "1. Stratégie patrimoniale : état des lieux complet (revenus, épargne, fiscalité, projets) et vision à long terme",
          "2. Solution adaptée mise en place : sélection de produits financiers ou immobiliers sur-mesure",
          "3. Accompagnement & pilotage : suivi régulier et ajustement de la stratégie à chaque évolution"
        ]
      },
      {
        title: "À qui s'adresse la gestion de patrimoine à Annecy ?",
        body: "Beaucoup pensent à tort que la gestion de patrimoine est réservée aux fortunes établies. À Annecy, j'accompagne aussi bien des jeunes actifs qui mettent en place leur première stratégie d'épargne (PEA, assurance vie, PER) que des dirigeants d'entreprise, des frontaliers Suisse, des professions libérales et des retraités qui souhaitent optimiser leurs revenus et préparer leur transmission.",
        bullets: [
          "Particuliers : salariés du privé, fonctionnaires, indépendants",
          "Dirigeants et chefs d'entreprise (TNS, assimilés salariés)",
          "Professions libérales et indépendants",
          "Frontaliers Suisse (optimisation fiscale franco-suisse)",
          "Comités Sociaux et Économiques (CSE) — formations gratuites",
          "Retraités préparant la transmission de leur patrimoine"
        ]
      },
      {
        title: "Mes domaines d'expertise patrimoniale",
        body: "En tant que conseiller indépendant, j'interviens sur l'intégralité des leviers patrimoniaux disponibles en France, en m'appuyant sur un réseau de partenaires sélectionnés rigoureusement.",
        bullets: [
          "Optimisation fiscale et défiscalisation (Pinel, LMNP, Malraux, Monuments Historiques)",
          "SCPI de rendement et SCPI fiscales",
          "Assurance vie multisupport et assurance vie luxembourgeoise",
          "Plan Épargne Retraite (PER) individuel et entreprise",
          "Préparation retraite et revenus complémentaires",
          "Donation, succession, démembrement de propriété, SCI familiale",
          "Trésorerie d'entreprise, épargne salariale, prévoyance dirigeant",
          "Renégociation assurance de prêt (Loi Lemoine)",
          "Conseil patrimonial pour frontaliers Suisse"
        ]
      }
    ]}
    faq={[
      { q: "Combien coûte un bilan patrimonial à Annecy ?",
        a: "Le bilan patrimonial proposé est entièrement offert et sans engagement. Aucun honoraire n'est facturé au client : la rémunération s'effectue uniquement auprès des partenaires fournisseurs de solutions, comme un courtier immobilier." },
      { q: "Faut-il avoir un patrimoine important pour faire appel à un CGP à Annecy ?",
        a: "Non. La gestion de patrimoine s'adresse à toute personne qui souhaite structurer ses finances. J'accompagne aussi bien des épargnants débutants (à partir de 50 € de versement mensuel) que des patrimoines complexes." },
      { q: "Quelle est la différence entre un CGP, un CGPI et un CIF ?",
        a: "Un CGP est un conseiller en gestion de patrimoine, généralement salarié d'une banque ou d'un assureur. Un CGPI est indépendant. Un CIF (Conseiller en Investissements Financiers) est un statut réglementé par l'AMF qui autorise à conseiller sur des placements financiers. Arthur Vacogne cumule les statuts CGPI et CIF, garantissant indépendance et compétence reconnue." },
      { q: "Les rendez-vous se font-ils uniquement à Annecy ?",
        a: "Non. Les rendez-vous se tiennent à Annecy / Annecy-le-Vieux, mais aussi en visio sur toute la France (Lyon, Grenoble, Paris) et la Suisse pour les frontaliers." }
    ]}
  />
);

export default PageGestionPatrimoineAnnecy;
